import { Card, LabelValueRow, Tabs } from 'components/core-v2'

export const Loading = () => (
  <Tabs.Panel value="details">
    <Card.Wrapper className="mt-10">
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
    </Card.Wrapper>
  </Tabs.Panel>
)
